<template>

    <CommonErrorComponent :code="error.code"
                          :title="error.title"
                          :meessage="error.message" />
</template>
<script charset="utf-8">
    import CommonErrorComponent from '../components/BasicControls/CommonErrorComponent';
    export default {
        name: "notfoundpage",
        components: {
            CommonErrorComponent
        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
                error: {
                    code: 404,
                    title: this.$t('com.file.not-found.not-found'),
                    message: this.$t('com.file.not-found.not-found-info')
                }
            }
        },
        mounted() { },
        unmount() { },
        methods: {},
    }

</script>
